<template>
  <div class="email">
    <a-form
      :form="form"
      @submit="handleToPay"
    >
      <div class="sms_list">
        <div class="sms_item">
          <p
            class="item_title"
            style="white-space: nowrap; text-align: right"
          >
            {{ $t('message["1053"]') }}：
          </p>
          <div class="item_main buy_input">
            <h2 class="total_num">
              {{ payData.currentNum }} {{ $t('message["307"]') }}
            </h2>
          </div>
        </div>
        <div
          class="sms_item"
          :class="{'en-form-item': isEnglish}"
        >
          <p
            class="item_title"
            style="white-space: nowrap; text-align: right"
          >
            {{ $t('message["398"]') }}：
          </p>
          <a-form-item class="item_main buy_input item_radio_group">
            <div>
              <a-radio-group
                v-model="payData.num"
                @change="onSelectNum"
              >
                <a-radio :value="500">
                  500{{ numberArticle }}
                </a-radio>
                <a-radio :value="1000">
                  1000{{ numberArticle }}
                </a-radio>
                <a-radio :value="2000">
                  2000{{ numberArticle }}
                </a-radio>
                <a-radio :value="0">
                  {{ $t('message["957"]') }}
                  <a-form-item>
                    <a-input
                      v-decorator="[
                        'more_num',
                        {
                          initialValue: payData.more_num,
                          rules: [{ validator: checkMoreSmsNumber }],
                        }
                      ]"
                      type="text"
                      placeholder=">2000"
                      @focus="focusMoreSms"
                      @change="getMoreSms"
                    />
                    <span class="num_suffx">{{ numberArticle }}</span>
                  </a-form-item>
                </a-radio>
              </a-radio-group>
            </div>
          </a-form-item>
        </div>
        <div class="sms_item">
          <p
            class="item_title"
            style="white-space: nowrap; text-align: right"
          >
            {{ $t('message["474"]') }}：
          </p>
          <div class="item_main buy_input item_input_clear">
            <h2 class="total_price">
              {{ totalMoney }}{{ $t('message["1523"]') }}
            </h2>
          </div>
        </div>

        <div class="sms_item">
          <div class="item_main buy_input">
            <a-button
              type="primary"
              html-type="submit"
            >
              {{ $t('message["927"]') }}
            </a-button>
          </div>
        </div>
      </div>
      <form
        v-if="isShowForm"
        :id="formId"
        method="post"
        :action="posturl"
      >
        <input
          v-for="(value, key) in keyDatas"
          :key="key"
          :name="key"
          type="hidden"
          :value="value"
        >
      </form>
    </a-form>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapActions, mapState } from 'vuex'
import { checkMoreSmsNumber } from './common'
import { getLang } from '@/lib/storage'

const MAX_EMAIL_NUM = 100000000

export default {
  data () {
    return {
      MAX_EMAIL_NUM,
      form: this.$form.createForm(this),
      payData: {
        num: 1000,
        currentNum: 0,
        price: 0.01,
        more_num: 0
      },
      totalMoney: 0,
      formId: Math.random().toString(10).substring(2),
      formDatas: {},
      isShowForm: true
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    posturl () {
      return this.formDatas.posturl
    },
    keyDatas () {
      return this.formDatas.data
    },
    isEnglish () {
      return this.getLang() === 'en'
    },
    numberArticle () {
      return this.isEnglish ? '' : this.$t('message["307"]')
    }
  },
  watch: {
    baseinfo (newVal) {
      document.title = this.$t('message["1502"]') + ' - ' + newVal.projectname + '-' + newVal.comname
    }
  },
  created () {
    this.getSmsLaveInfo()
  },
  methods: {
    ...mapActions('config/service', ['getLaveInfo', 'pay']),
    getLang,
    checkMoreSmsNumber,
    handleToPay (e) {
      e.preventDefault()
      const _this = this
      _this.form.validateFields((err, values) => {
        if (!err) {
          let num = values.more_num === 0 ? Number(this.payData.num) : Number(values.more_num)
          let data = Object.assign({}, { num }, { money: _this.totalMoney }, { type: 2 })
          _this.toPay(data)
        }
      })
    },
    onSelectNum (e) {
      const { value } = e.target
      this.totalMoney = this.totalMoneyFormat(this.payData.price * value)
      this.form.setFieldsValue({ more_num: 0 })
    },
    focusMoreSms () {
      this.payData.num = 0
    },
    getMoreSms (e) {
      const { value } = e.target
      const currentValue = value > MAX_EMAIL_NUM ? MAX_EMAIL_NUM : value
      this.totalMoney = this.totalMoneyFormat(this.payData.price * currentValue)
    },
    async getSmsLaveInfo () {
      const chain = await this.getLaveInfo({ type: 2 })
      chain.onSuccess(res => {
        const { emailnum, emailPrice } = res
        this.payData = Object.assign(this.payData, { currentNum: emailnum }, { price: emailPrice })
        this.totalMoney = this.totalMoneyFormat(this.payData.price * this.payData.num)
      })
        .fetch()
    },
    async toPay (data) {
      const chain = await this.pay()
      chain.params(data)
        .onSuccess(res => {
          if (!res.error) {
            this.isShowForm = true
            this.formDatas = res
            setTimeout(() => {
              document.getElementById(this.formId).submit()
              this.isShowForm = false
            }, 1000)
          }
        })
        .fetch()
    },
    totalMoneyFormat (value) {
      return Math.round(value * 100) / 100
    }
  }
}
</script>

<style scoped lang="scss">
.sms_item {
  position: relative;
  min-height: 56px;
  // margin: 15px 0;
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
  .sms_input {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .item_title {
    width: 70px;
    position: absolute;
    font-size: 14px;
    color: #666;
    line-height: 24px;
    white-space: nowrap;
    text-align: right;
  }
  .item_radio_group {
    top: -5px;
  }
  .item_main {
    display: inline-block;
    position: absolute;
    left: 85px;
    // overflow: hidden;
    .total_num {
      position: relative;
      color: #42c27e;
      line-height: 24px;
    }
    .ant-radio-wrapper {
      .ant-row {
        display: inline-block;
        margin-top: -6px;
        .ant-form-explain {
          margin-left: 16px;
        }
      }
      input {
        width: 160px;
        margin: 0 16px;
        padding: 0 10px;
      }
    }
    .total_price {
      font-size: 24px;
      color: #5077aa;
      font-weight: 600;
      line-height: 24px;
    }
    .num_suffx {
      position: relative;
      left: -42px;
      margin: 0 5px;
      z-index: 100;
    }
  }
}
.en-form-item {
  margin-bottom: 34px;
}
</style>
<style lang="scss">
.email {
  margin-top: 24px;
  .ant-radio + * {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
  .ant-radio-wrapper {
    margin-right: 24px;
  }
}
</style>
